import { render, staticRenderFns } from "./DemandQuotedPrice.vue?vue&type=template&id=14bcb9c8&scoped=true&"
import script from "./DemandQuotedPrice.vue?vue&type=script&lang=js&"
export * from "./DemandQuotedPrice.vue?vue&type=script&lang=js&"
import style0 from "./DemandQuotedPrice.vue?vue&type=style&index=0&id=14bcb9c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bcb9c8",
  null
  
)

export default component.exports